import React from "react";

const Java_Long = () => {
  return (
    <div>
      <h1>Java Long</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Long in Java.</p>
    </div>
  );
};

export default Java_Long;
